<form
    name="form"
    (ngSubmit)="f.form.valid && proceesData(f)"
    #f="ngForm"
    novalidate
>
    <div class="row data-sect">
        <div class="col-lg-6">
            <div class="form-group">
                <mat-form-field>
                    <mat-select
                        disableOptionCentering
                        placeholder="Type"
                        [(ngModel)]="userData.typeId"
                        name="type"
                        #type="ngModel"
                        required
                        (selectionChange)="onTypeChange($event)"
                    >
                        <ng-container *ngFor="let item of typeList">
                            <mat-option [value]="item.id">{{ item?.type }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <mat-form-field>
                    <mat-select
                        disableOptionCentering
                        placeholder="Section"
                        [(ngModel)]="userData.sectionId"
                        name="section"
                        #section="ngModel"
                        required
                    >
                        <mat-option
                            *ngFor="let item of sectionList"
                            [value]="item.id"
                        >
                            {{ item.sections }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="form-group">
                <mat-form-field>
                    <input
                        matInput
                        placeholder="Sub Section Name"
                        [(ngModel)]="userData.subSection"
                        name="subsection"
                        #subsection="ngModel"
                        required
                    >
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-12 margin-top-20 text-center">
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                [disabled]="!f.valid"
                *ngIf="!userData?.id"
            >
                Submit
            </button>
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                *ngIf="userData?.id"
            >
                Update
            </button>
        </div>
    </div>
</form>



<br>
<div class="col-lg-12 row">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3>Sub section List</h3>
        </div>
        <hr>
        <table
            class="table"
            [svData]="subSectionList"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="subSectionList && subSectionList.length > 0"
        >
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Section</th>
                    <th>Sub Section</th>
                    <th class="text-center">Edit</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td>{{ item.type }}</td>
                    <td>{{ item.sections }}</td>
                    <td>{{ item.subSections }}</td>


                    <td class="text-center">
                        <img
                            src="assets/icons/edit.png"
                            class="cursor-pointer"
                            (click)="editData(item.id)"
                        >
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteData(item.id)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="subSectionList?.length > pageSize">
                <tr>
                    <td
                        colspan="5"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="subSectionList?.length <= 0">No data found</div>
    </div>
</div>
